<template>
  <div v-if="visible" class="model-message-send-overlay" @click="handleOverlayClick">
    <div class="model-message-send-modal" @click.stop>

      <!-- STEP 1 - LISTAGEM -->
      <template v-if="chat.hsm.step === 1">
        <!-- Header -->
        <div class="model-message-send-header">
          <div class="model-message-send-title">
            <div class="model-message-send-icon">
              <MessagesSquare :size="20" />
            </div>
            <h3>{{ getTranslations('expression_1499') }}</h3>
          </div>

          <!-- Search -->
          <div class="model-message-send-search">
            <div class="model-message-send-search-container">
              <div class="model-message-send-search-icon">
                 <Search :size="14" />
              </div>
              <input type="text" v-model="searchQuery" @keyup.enter="handleSearch" :placeholder="getTranslations('expression_712')"
                class="model-message-send-search-input" />
              <button v-if="searchQuery" @click="clearSearch" class="model-message-send-search-clear">
                <X :size="15" />
              </button>
            </div>
          </div>

          <button class="model-message-send-close" @click="closeModal">
           <X :size="20" />
          </button>
        </div>

        <!-- Body -->
        <div class="model-message-send-body">
          <div v-if="chat.hsm.data" class="model-message-send-content">

            <div v-if="isSearching" class="model-message-send-search-loading">
              <div class="model-message-send-search-spinner">
                <div class="model-message-send-search-spinner-circle"></div>
              </div>
              <p class="model-message-send-search-loading-text">{{ getTranslations('expression_1520') }}</p>
            </div>

            <div v-else-if="showNoResultsMessage" class="model-message-send-no-results">
              <div class="model-message-send-no-results-icon">
             <SearchX :size="48" :stroke-width="1.5" />
              </div>
              <p class="model-message-send-no-results-text">
                {{ getTranslations('expression_1518') }} "<strong>{{ searchQuery }}</strong>"
              </p>
              <p class="model-message-send-no-results-subtext">{{ getTranslations('expression_1519') }}</p>
              <button class="model-message-send-clear-search-btn" @click="clearSearch">
                {{ getTranslations('expression_1502') }}
              </button>
            </div>

            <div v-else-if="templates.data.length > 0" class="model-message-send-table-container">
              <div class="model-message-send-table-wrapper">
                <table class="model-message-send-table">
                  <thead class="model-message-send-thead">
                    <tr>
                      <th class="model-message-send-th name-column">{{ getTranslations('expression_411') }}</th>
                      <th class="model-message-send-th category-column">{{ getTranslations('expression_412') }}</th>
                      <th class="model-message-send-th preview-column">{{ getTranslations('expression_413') }}</th>
                      <th class="model-message-send-th language-column">{{ getTranslations('expression_647') }}</th>
                    </tr>
                  </thead>
                  <tbody class="model-message-send-tbody">
                    <tr v-for="(template, index) in templates.data" v-if="template.status.toLowerCase() === 'approved'"
                      :key="index" @click.prevent="showHSM(template)" class="model-message-send-row">

                      <td class="model-message-send-td name-column">
                        <div class="model-message-send-cell">
                          <span v-b-tooltip.bottom :title="template.name || '---'" class="model-message-send-text">
                            {{ (template.name || '---') | truncate(30) }}
                          </span>
                        </div>
                      </td>

                      <td class="model-message-send-td category-column">
                        <div class="model-message-send-cell center">
                          <span v-b-tooltip.bottom :title="template.category || '---'"
                            class="model-message-send-category">
                            {{ template.category || '---' }}
                          </span>
                        </div>
                      </td>

                      <td class="model-message-send-td preview-column">
                        <div class="model-message-send-cell">
                          <span v-b-tooltip.bottom :title="template.components[0].text || '---'"
                            class="model-message-send-description">
                            {{ template.components[0].text | truncate(70) }}
                          </span>
                        </div>
                      </td>

                      <td class="model-message-send-td language-column">
                        <div class="model-message-send-cell center">
                          <span v-b-tooltip.bottom :title="template.language || '---'"
                            class="model-message-send-language">
                            {{
                              template.language === 'pt_BR' ? '🇧🇷 Português' :
                                template.language === 'en' ? '🇺🇸 English' :
                                  template.language === 'en_US' ? '🇺🇸 English' :
                                    template.language === 'es' ? '🇪🇸 Español' :
                                      template.language
                            }}
                          </span>
                        </div>
                      </td>

                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div v-else-if="!searchQuery.trim()" class="model-message-send-empty">
              <div class="model-message-send-empty-icon">
               <FolderMinus :size="48" class="text-gray-400" />
              </div>
              <p class="model-message-send-empty-text">{{ getTranslations('expression_823') }}</p>
            </div>
          </div>

          <div v-else class="model-message-send-loading">
            <div class="model-message-send-spinner">
              <div class="model-message-send-spinner-circle"></div>
            </div>
            <p class="model-message-send-loading-text">{{ getTranslations('expression_36') }}</p>
          </div>

          <!-- Pagination -->
          <div v-if="shouldShowPagination" class="model-message-send-pagination">
            <Pagination v-if="isWhatsappCloudApiActive" :items="paginationData"
              commit="SET_TEMPLATES_PAGINATION_CLOUD_API" @page-changed="onPageChange" />

          </div>

        </div>

        <div class="model-message-send-footer">
          <button class="model-message-send-cancel" @click="closeModal">
            {{ getTranslations('expression_355') }}
          </button>
        </div>
      </template>

      <!-- STEP 2 - Template estilizado com prévia -->
      <template v-if="chat.hsm.step === 2">
        <div class="model-message-send-step2">

          <!-- Header com aviso -->
          <div class="model-message-send-step2-header">
            <div class="step2-alert">
              <div class="alert-icon">
                <i class="bx bx-info-circle"></i>
              </div>
              <div class="alert-content">
                <h4>{{ getTranslations('expression_822') }}</h4>
                <p>Preencha as variáveis obrigatórias do modelo selecionado</p>
              </div>
            </div>
          </div>

          <!-- Conteúdo principal em duas colunas -->
          <div class="model-message-send-step2-body">

            <!-- Coluna esquerda - Formulário -->
            <div class="step2-form-column">
              <div class="step2-form-content">

                <!-- Upload de mídia para header -->
                <div v-if="media_header" class="media-upload-section">
                  <h5 class="section-title">
                    <i class="bx bx-image-alt"></i>
                    {{ getTranslations('expression_866') }}
                  </h5>

                  <!-- Botão de Upload Simples -->
                  <div class="campaign-media-upload-button-wrapper">
                    <button @click.stop="uploadFileHSM" class="campaign-media-upload-button-simple">

                      <!-- Ícone baseado no tipo -->
                      <div class="campaign-upload-icon-simple">
                        <i v-if="chat.hsm.data.components[index_header].format === 'IMAGE'" class="bx bx-image-add"></i>
                        <i v-else-if="chat.hsm.data.components[index_header].format === 'VIDEO'"
                          class="bx bx-video-plus"></i>
                        <i v-else-if="chat.hsm.data.components[index_header].format === 'DOCUMENT'"
                          class="bx bx-file-pdf"></i>
                        <i v-else class="bx bx-file-plus"></i>
                      </div>

                      <!-- Texto do botão -->
                      <span class="campaign-upload-text-simple">
                        <span v-if="chat.hsm.data.components[index_header].format === 'IMAGE'">
                          {{ getTranslations('expression_1511') }}
                        </span>
                        <span v-else-if="chat.hsm.data.components[index_header].format === 'VIDEO'">
                          Escolha um ficheiro mp4
                        </span>
                        <span v-else>
                          {{ getTranslations('expression_1510') }}
                        </span>
                      </span>
                    </button>

                    <!-- Input file oculto -->
                    <input type="file" @change="loadFileHSM()" id="fileHandlerHSM" style="display: none;">
                  </div>

                  <!-- Preview da mídia selecionada -->
                  <div v-if="file.file" class="media-preview-compact">
                    <!-- Imagem -->
                    <div v-if="['image/png', 'image/jpeg', 'image/jpg'].includes(file.mimetype)"
                      class="media-preview-item">
                      <div class="media-thumbnail">
                        <img :src="file.file" alt="Preview" />
                      </div>
                      <div class="media-info">
                        <span class="media-type">Imagem selecionada</span>
                        <div class="media-actions">
                          <button @click="uploadFileHSM" class="media-action-btn">
                            <i class="bx bx-edit"></i>
                          </button>
                          <button @click="removeFileHSM" class="media-action-btn remove">
                            <i class="bx bx-x"></i>
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- Vídeo -->
                    <div v-else-if="['video/mpeg', 'video/mp4'].includes(file.mimetype)" class="media-preview-item">
                      <div class="media-thumbnail video">
                        <video :src="file.file"></video>
                        <div class="video-play-icon">
                          <i class="bx bx-play-circle"></i>
                        </div>
                      </div>
                      <div class="media-info">
                        <span class="media-type">Vídeo selecionado</span>
                        <div class="media-actions">
                          <button @click="uploadFileHSM" class="media-action-btn">
                            <i class="bx bx-edit"></i>
                          </button>
                          <button @click="removeFileHSM" class="media-action-btn remove">
                            <i class="bx bx-x"></i>
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- Documento -->
                    <div v-else class="media-preview-item">
                      <div class="media-thumbnail document">
                        <i class="bx bx-file-blank"></i>
                      </div>
                      <div class="media-info">
                        <span class="media-type">Documento PDF</span>
                        <small class="media-size">{{ (file.file.length / 1024 / 1024 * 0.75).toFixed(2) }} MB</small>
                        <div class="media-actions">
                          <button @click="uploadFileHSM" class="media-action-btn">
                            <i class="bx bx-edit"></i>
                          </button>
                          <button @click="removeFileHSM" class="media-action-btn remove">
                            <i class="bx bx-x"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Variáveis do formulário -->
                <div class="variables-section">
                  <h5 class="section-title">
                    <i class="bx bx-code-alt"></i>
                    Variáveis do Template
                  </h5>

                  <!-- Header com variável -->
                  <div v-if="variable_header" class="variable-group">
                    <label class="variable-label">
                      {{ getTranslations('expression_650') }} - {{ getTranslations('expression_656') }} {{ 1 }}
                    </label>
                    <div class="variable-input-container">
                      <input type="text" class="variable-input" maxlength="30"
                        v-model="chat.hsm.history.components[index_header].parameters[0].text"
                        @keyup.prevent="set_preview_header" ref="editvariables_modal_1" id="editvariables_modal_1"
                        placeholder="Digite o valor da variável...">

                      <!-- Dropdown de variáveis -->
                      <div class="variable-dropdown-trigger" :data-dropdown="1" @click.prevent="dropdownActive(1)">
                        <i class="bx bx-code"></i>

                        <div class="variable-dropdown" :class="{ active: dropdownShow === 1 }">
                          <div class="dropdown-header">
                            <span>Variáveis Disponíveis</span>
                          </div>
                          <div class="dropdown-items">
                            <div v-for="(item, index) in configs.chat_variables" :key="`var_${index}`"
                              class="dropdown-item" @click.prevent="selectVariable(1, item)">
                              <i :class="item.icon"></i>
                              <span>{{ item.name }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Body com variáveis -->
                  <div v-for="(variable, index) in chat.hsm.history.components"
                    v-if="['body', 'BODY'].includes(variable.type)" :key="index">
                    <div v-for="(parameter, key) in variable.parameters" :key="key" class="variable-group">
                      <label class="variable-label">
                        {{ getTranslations('expression_1505') }} - {{ key + 1 }}
                      </label>
                      <div class="variable-input-container">
                        <input type="text" class="variable-input" maxlength="30" v-model="parameter.text"
                          @keyup.prevent="set_preview_body" :ref="`editvariables_modal_2_${key}`"
                          :id="`editvariables_modal_2_${key}`" placeholder="Digite o valor da variável...">

                        <!-- Dropdown de variáveis -->
                        <div class="variable-dropdown-trigger" :data-dropdown="`2_${key}`"
                          @click.prevent="dropdownActive(`2_${key}`)">
                          <i class="bx bx-code"></i>

                          <div class="variable-dropdown" :class="{ active: dropdownShow === `2_${key}` }">
                            <div class="dropdown-header">
                              <span>Variáveis Disponíveis</span>
                            </div>
                            <div class="dropdown-items">
                              <div v-for="(item, indexSecondary) in configs.chat_variables"
                                :key="`var_${indexSecondary}`" class="dropdown-item"
                                @click.prevent="selectVariable(`2_${key}`, item)">
                                <i :class="item.icon"></i>
                                <span>{{ item.name }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Button URL -->
                  <div v-if="variable_button_url" class="variable-group">
                    <label class="variable-label">
                      {{ getTranslations('expression_670') }} - {{ getTranslations('expression_656') }} {{ 1 }}
                    </label>
                    <div class="variable-input-container">
                      <input type="text" class="variable-input" maxlength="30"
                        v-model="chat.hsm.history.components[index_button_url].parameters[0].text"
                        @keyup.prevent="sendValidate" ref="editvariables_modal_3" id="editvariables_modal_3"
                        placeholder="Digite a URL...">

                      <!-- Dropdown de variáveis -->
                      <div class="variable-dropdown-trigger" :data-dropdown="3" @click.prevent="dropdownActive(3)">
                        <i class="bx bx-code"></i>

                        <div class="variable-dropdown" :class="{ active: dropdownShow === 3 }">
                          <div class="dropdown-header">
                            <span>Variáveis Disponíveis</span>
                          </div>
                          <div class="dropdown-items">
                            <div v-for="(item, index) in configs.chat_variables" :key="`var_${index}`"
                              class="dropdown-item" @click.prevent="selectVariable(3, item)">
                              <i :class="item.icon"></i>
                              <span>{{ item.name }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Coluna direita - Prévia -->
            <div class="step2-preview-column">
              <div class="preview-container">
                <div class="preview-header">
                  <h5>
                    <i class="bx bx-eye"></i>
                    Prévia da Mensagem
                  </h5>
                </div>

                <!-- Message Preview Simples -->
                <div class="message-preview-simple">
                  <div class="message-card">
                    <div class="message-content-scrollable">
                      <!-- Mídia do header -->
                      <div v-if="file.file" class="preview-media">
                        <!-- Imagem -->
                        <div v-if="['image/png', 'image/jpeg', 'image/jpg'].includes(file.mimetype)"
                          class="preview-image">
                          <img :src="file.file" alt="Imagem" />
                        </div>
                        <!-- Vídeo -->
                        <div v-else-if="['video/mpeg', 'video/mp4'].includes(file.mimetype)" class="preview-video">
                          <video :src="file.file" controls></video>
                          <div class="video-play-overlay">
                            <i class="bx bx-play-circle"></i>
                          </div>
                        </div>
                        <!-- Documento -->
                        <div v-else class="preview-document">
                          <div class="document-icon-large">
                            <i class="bx bx-file-blank"></i>
                          </div>
                          <div class="document-details">
                            <span class="document-name">documento.pdf</span>
                            <small class="document-type">PDF</small>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Header text -->
                    <div v-if="preview_header" class="preview-header-text">
                      <span v-html="preview_header"></span>
                    </div>

                    <!-- Body -->
                    <div class="preview-body-text">
                      <span :class="preview_body ? 'text-content' : 'text-placeholder'"
                        v-html="preview_body ? preview_body : 'O corpo da mensagem aparecerá aqui...'">
                      </span>
                    </div>

                    <!-- Footer -->
                    <div v-if="preview_footer" class="preview-footer-text">
                      <span v-html="preview_footer"></span>
                    </div>

                    <!-- Buttons -->
                    <div v-if="preview_button" class="preview-buttons">
                      <div v-for="(button, index) in preview_button" :key="index" class="preview-button">
                        <button class="template-button-preview" :class="button.type.toLowerCase()">
                          <i v-if="button.type === 'URL'" class="bx bx-link-external"></i>
                          <i v-else-if="button.type === 'PHONE_NUMBER'" class="bx bx-phone"></i>
                          <i v-else-if="button.type === 'QUICK_REPLY'" class="bx bx-message"></i>
                          <span>{{ button.text }}</span>
                        </button>
                      </div>
                    </div>

                    <!-- Message info -->
                    <div class="preview-message-info">
                      <span class="message-type">Modelo de mensagem</span>
                      <div class="message-status">
                        <i class="bx bx-check-double"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Footer -->
          <div class="model-message-send-step2-footer">
            <button class="step2-cancel-btn" @click.prevent="chat.hsm.step = 1; chat.hsm.data = {}">
              <i class="bx bx-arrow-back"></i>
              {{ getTranslations('expression_113') }}
            </button>
            <button class="step2-send-btn" :class="{ disabled: !go_send }" :disabled="!go_send"
              @click.prevent="sendHsm">
              <i class="bx bx-send"></i>
              {{ getTranslations('expression_562') }}
            </button>
          </div>
        </div>
      </template>


    </div>
  </div>
</template>


<script>
import { mapGetters, mapState } from "vuex";
import $ from "jquery";
import no_pic from "../../assets/img/no-pic.png";
import Swal from "sweetalert2";
import TextCount from "../general/TextCount";
import Pagination from "../theme/Pagination.vue";
import { Search, SearchX, X, MessagesSquare, FolderMinus } from 'lucide-vue'
export default {
  name: "ModalSendTemplateHSM",
  components: {
    TextCount,
    Pagination,
    Search,
    SearchX,
    X,
    FolderMinus,
    MessagesSquare,
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close'],
  computed: {
    ...mapState(['templates', 'chat', 'channels', 'configs', 'me', 'operators']),

    ...mapGetters([
      'getChannelObject',
    ]),

    hasSearchResults() {
      return this.searchQuery.trim() && this.templates.data && this.templates.data.length > 0;
    },
    showNoResultsMessage() {
      return this.searchQuery.trim() && this.templates.data && this.templates.data.length === 0 && !this.isSearching;
    },


    paginationData() {
      return this.templates.pagination || {};
    },
    shouldShowPagination() {
      return this.templates.data &&
        this.templates.data.length > 0 &&
        this.templates.pagination &&
        this.templates.pagination.last_page > 1;
    },
    // HSM
    text_body_original() {
      let text = '';
      if (this.chat.hsm.data.components !== undefined) {
        this.chat.hsm.data.components.forEach(component => {
          if (component.type === 'BODY') {
            text = component.text.toString();
          }
        });
      }
      return text;
    },
    text_header_original() {
      let text = '';
      if (this.chat.hsm.data.components !== undefined) {
        this.chat.hsm.data.components.forEach(component => {
          if (component.type === 'HEADER' && component.format === 'TEXT') {
            text = component.text.toString();
          }
        });
      }
      return text;
    },
    button_validate() {
      if (this.type_button === 0 && this.chat.hsm.data.buttons.length >= 2) {
        return false
      } else return !(this.type_button === 1 && this.chat.hsm.data.buttons.length >= 3);
    },

    // END HSM

  },
  data() {
    return {
      searchQuery: '',
      isSearching: false,
      no_pic: no_pic,
      // Dropdown
      dropdownClickOption: null,
      inputMsgId: null,
      dropdownShow: false,
      variable_body: 0,
      variable_button_url: false,
      index_button_url: null,
      index_header: null,
      type_button: null,
      type_button_cta: null,
      text: [],
      preview_body: '',
      preview_button: false,
      preview_footer: false,
      preview_header: false,
      variable_header: false,
      media_header: false,
      file: {
        file: null,
        mimetype: null
      },
      go_send: true
    }
  },
  mounted() {
    $('#sendTemplateModal').on('hidden.bs.modal', () => {
      this.chat.hsm = {
        step: 1,
        data: {}
      }
    })
  },
  methods: {

    languageMap(term) {
      const lowerTerm = term.toLowerCase().trim();

      const map = {
        'português': 'pt_BR',
        'portugues': 'pt_BR',
        'portuguese': 'pt_BR',
        'inglês': 'en_US',
        'ingles': 'en_US',
        'english': 'en_US',
        'espanhol': 'es',
        'espanol': 'es',
        'spanish': 'es'
      };

      return map[lowerTerm] || null;
    },
    changePage(page) {
      this.$emit('page-changed', page);
    },
    resetModal() {
      // Reset do chat HSM
      this.chat.hsm = {
        step: 1,
        data: {},
        history: {
          components: []
        }
      };
      // Reset das variáveis de controle
      this.searchQuery = '';
      this.isSearching = false;
      this.dropdownShow = false;
      this.variable_body = 0;
      this.variable_button_url = false;
      this.index_button_url = null;
      this.index_header = null;
      this.type_button = null;
      this.type_button_cta = null;
      this.text = [];
      this.preview_body = '';
      this.preview_button = false;
      this.preview_footer = false;
      this.preview_header = false;
      this.variable_header = false;
      this.media_header = false;
      this.go_send = true;

      // Reset do arquivo
      this.file = {
        file: null,
        mimetype: null
      };

      // Limpar input de arquivo se existir
      const fileInput = document.getElementById('fileHandlerHSM');
      if (fileInput) {
        fileInput.value = '';
      }
    },
    closeModal() {
      this.searchQuery = '';
      this.isSearching = false;
      this.resetModal();
      this.$emit('close');
    },

    handleOverlayClick() {
      this.closeModal();
    },
    handleSearch() {
      
      this.isSearching = true;

      this.searchTimeout = setTimeout(() => {
        const mappedLang = this.languageMap(this.searchQuery);
        const search = mappedLang || this.searchQuery.trim();

        this.$store.dispatch('getTemplates', {
          id: this.chat.ticket.channel_id,
          search: search,
          page: 1 // Reset para primeira página
        }).finally(() => {
          this.isSearching = false;
        });
      }, 1000);
    },

    onPageChange(page) {
      this.$store.dispatch('getTemplates', {
        id: this.chat.ticket.channel_id,
        search: this.searchQuery.trim(),
        page: page
      });
    },
    clearSearch() {
      this.searchQuery = '';
      this.$store.dispatch('getTemplates', {
        id: this.chat.ticket.channel_id
      });
    },
    isDialogActive() {
      return this.getChannelObject('id', this.chat.ticket.channel_id).integrations[9].status_key;
    },

    isWhatsappCloudApiActive() {
      return this.getChannelObject('id', this.chat.ticket.channel_id).integrations[12]
        && this.getChannelObject('id', this.chat.ticket.channel_id).integrations[12].status_key;
    },

    // HSM
    sendValidate() {
      this.go_send = true
      if (this.chat.hsm.history.components) {
        this.chat.hsm.history.components.forEach(component => {
          if (component.type === 'header') {
            component.parameters.forEach((parameter) => {
              if (parameter.type === 'text') {
                if (parameter.text === '' || parameter.text === null) {
                  this.go_send = false
                }
              } else {
                if (this.file.file === '' || this.file.file === null) {
                  this.go_send = false
                }
              }
            })
          } else if (component.type === 'body') {
            component.parameters.forEach((parameter) => {
              if (parameter.text === '' || parameter.text === null) {
                this.go_send = false
              }
            })
          } else if (component.type === 'button') {
            if (component.sub_type === 'url') {
              if (component.parameters[0].text === '' || component.parameters[0].text === null) {
                this.go_send = false
              }
            }
          }
        });
      }
    },
    set_preview_body() {
      let text = this.text_body_original;
      this.chat.hsm.history.components.forEach(history => {
        if (history.type === 'body') {
          if (history.parameters[0]) {
            if (history.parameters[0].text) {
              text = text.replaceAll('{{1}}', history.parameters[0].text);
            }
            if (history.parameters[1]) {
              if (history.parameters[1].text) {
                text = text.replaceAll('{{2}}', history.parameters[1].text);
              }
              if (history.parameters[2]) {
                if (history.parameters[2].text) {
                  text = text.replaceAll('{{3}}', history.parameters[2].text);
                }
                if (history.parameters[3]) {
                  if (history.parameters[3].text) {
                    text = text.replaceAll('{{4}}', history.parameters[3].text);
                  }
                }
              }
            }
          }
        }
      })
      this.preview_body = text;
      this.sendValidate()
    },
    set_preview_footer() {
      this.preview_footer = false
      this.chat.hsm.data.components.forEach(history => {
        if (history.type === 'FOOTER') {
          this.preview_footer = history.text
        }
      })
      this.sendValidate()
    },
    set_preview_button() {
      this.preview_button = false
      this.chat.hsm.data.components.forEach(history => {
        if (history.type === 'BUTTONS') {
          this.preview_button = history.buttons
        }
      })
      this.sendValidate()
    },
    set_preview_header() {
      this.preview_header = false
      let text = this.text_header_original;
      this.chat.hsm.history.components.forEach(history => {
        if (history.type === 'header') {
          if (history.parameters[0]) {
            if (history.parameters[0].text) {
              text = text.replaceAll('{{1}}', history.parameters[0].text);
            }
          }
        }
      })
      this.preview_header = text === '' ? false : text;
      this.sendValidate()
    },
    clear() {
      const files = document.getElementById('fileHandlerHSM')
      if (files) {
        files.value = ''
      }
      this.file = {
        file: null,
        mimetype: null
      };
    },
    loadFileHSM() {
      const files = document.getElementById('fileHandlerHSM')
      if (files.files && files.files[0]) {
        const file = files.files[0]

        // IMAGE
        if (this.chat.hsm.data.components[this.index_header].format === 'IMAGE') {
          if (['image/png', 'image/jpeg', 'image/jpg'].includes(file.type)) {
            const size = (file.size / 1024) / 1024
            if (size <= 16) {
              const FR = new FileReader();
              FR.addEventListener('load', (e) => {
                this.file.file = e.target.result
                this.file.mimetype = file.type
              })
              FR.readAsDataURL(file)
            } else {
              Swal.fire(
                `${this.getTranslations('expression_683')}`,
                `${this.getTranslations('expression_681')} <br/> <small>${this.getTranslations('expression_682')} ${file.name}</small>`,
                'warning'
              )
            }
          } else {
            Swal.fire(
              `${this.getTranslations('expression_683')}`,
              `${this.getTranslations('expression_684')} <br/> <small>${this.getTranslations('expression_892')}</small> <br/> <small>${this.getTranslations('expression_682')} ${file.name}</small>`,
              'warning'
            )
          }
        }

        // DOCUMENT
        else if (this.chat.hsm.data.components[this.index_header].format === 'DOCUMENT') {
          if (['application/pdf'].includes(file.type)) {
            const size = (file.size / 1024) / 1024
            if (size <= 16) {
              const FR = new FileReader();
              FR.addEventListener('load', (e) => {
                this.file.file = e.target.result
                this.file.mimetype = file.type
              })
              FR.readAsDataURL(file)

            } else {
              Swal.fire(
                `${this.getTranslations('expression_683')}`,
                `${this.getTranslations('expression_681')} <br/> <small>${this.getTranslations('expression_682')} ${file.name}</small>`,
                'warning'
              )
            }
          } else {
            Swal.fire(
              `${this.getTranslations('expression_683')}`,
              `${this.getTranslations('expression_684')} <br/> <small>${this.getTranslations('expression_685')}</small> <br/> <small>${this.getTranslations('expression_682')} ${file.name}</small>`,
              'warning'
            )
          }
        }
        // VIDEO
        else if (this.chat.hsm.data.components[this.index_header].format === 'VIDEO') {
          if (['video/mpeg', 'video/mp4'].includes(file.type)) {
            const size = (file.size / 1024) / 1024
            if (size <= 16) {
              const FR = new FileReader();
              FR.addEventListener('load', (e) => {
                this.file.file = e.target.result
                this.file.mimetype = file.type
              })
              FR.readAsDataURL(file)

            } else {
              Swal.fire(
                `${this.getTranslations('expression_683')}`,
                `${this.getTranslations('expression_681')} <br/> <small>${this.getTranslations('expression_682')} ${file.name}</small>`,
                'warning'
              )
            }
          } else {
            Swal.fire(
              `${this.getTranslations('expression_683')}`,
              `${this.getTranslations('expression_684')} <br/> <small>${this.getTranslations('expression_825')}</small> <br/> <small>${this.getTranslations('expression_682')} ${file.name}</small>`,
              'warning'
            )
          }
        }
      }
      $('#fileHandlerHSM').val('')
      setTimeout(() => {
        this.sendValidate()
      }, 200)
    },
    removeFileHSM() {
      this.file.file = null
      this.file.mimetype = null
      $('#fileHandlerHSM').val('')
      this.sendValidate()
    },
    uploadFileHSM() {
      $('#fileHandlerHSM').click()
    },
    clearTemplate() {
      this.templates.step = 1
      const files = document.getElementById('fileHandlerHSM')
      if (files) {
        files.value = ''
      }
      this.chat.hsm.data = {
        header: {
          format: "TEXT",
          content: "",
          examples: []
        },
        body: {
          text: "",
          examples: []
        },
        footer: {
          text: ""
        },
        buttons: [],
        category: null,
        name: null,
        language: null,
        options: {
          header: false,
          body: true,
          footer: false,
          buttons: false,
        },
        header_file: {
          text: '',
          file: null,
          mimetype: null,
          filename: null
        }
      }
      this.sendValidate()
    },
    showHSM(payload) {
      if (payload !== undefined) {
        // Padrão
        this.chat.hsm.step = 2;
        this.chat.hsm.data = payload;
        this.chat.hsm.history = {};
        this.chat.hsm.history.name = payload.name;
        this.chat.hsm.history.namespace = payload.namespace;
        this.chat.hsm.history.language = payload.language;
        this.chat.hsm.history.components = [];
        this.variable_button_url = false
        this.variable_header = false
        this.media_header = false
        this.file = {
          file: null,
          mimetype: null
        }
        payload.components.forEach((component, index) => {
          if (component.type === 'BODY' && component.example) {
            const obj = {
              type: 'body',
              parameters: []
            }
            for (let x = 0; x < component.example.body_text[0].length; x++) {
              obj.parameters.push({
                type: 'text',
                text: ''
              })
            }
            this.chat.hsm.history.components.push(obj)
          } else if (component.type === 'BODY') {
            const obj = {
              type: 'body',
              parameters: []
            }
            let qty = 0;
            if (component.text.includes("{{1}}")) {
              qty++;
            }
            if (component.text.includes("{{2}}")) {
              qty++;
            }
            if (component.text.includes("{{3}}")) {
              qty++;
            }
            if (component.text.includes("{{4}}")) {
              qty++;
            }
            for (let x = 0; x < qty; x++) {
              obj.parameters.push({
                type: 'text',
                text: ''
              })
            }
            this.chat.hsm.history.components.push(obj)
          } else if (component.type === 'BUTTONS') {
            this.index_button_url = index
            component.buttons.forEach((button) => {
              if (button.type === 'URL' && button.url !== undefined && button.url.includes('{{1}}')) {
                const objButton = {
                  type: 'button',
                  sub_type: 'url',
                  index: "1",
                  parameters: [
                    {
                      type: 'text',
                      text: ''
                    }
                  ]
                }
                this.chat.hsm.history.components.push(objButton)
                this.variable_button_url = true
              }
            })
          } else if (component.type === 'HEADER' && component.format === 'TEXT') {
            if (component.text.includes('{{1}}')) {
              this.index_header = index
              const objHeader = {
                type: 'header',
                parameters: [
                  {
                    type: 'text',
                    text: ''
                  }
                ]
              }
              this.chat.hsm.history.components.push(objHeader)
              this.variable_header = true
            }
          } else if (component.type === 'HEADER' && component.format !== 'TEXT') {
            this.index_header = index
            let objHeaderTemp = {}
            if (component.format === 'VIDEO') {
              objHeaderTemp = {
                parameters: [
                  {
                    type: 'video',
                    video: {
                      link: ''
                    }
                  }
                ]
              }
            } else if (component.format === 'IMAGE') {
              objHeaderTemp = {
                parameters: [
                  {
                    type: 'image',
                    image: {
                      link: ''
                    }
                  }
                ]
              }
            } else {
              objHeaderTemp = {
                parameters: [
                  {
                    type: 'document',
                    document: {
                      link: ''
                    }
                  }
                ]
              }
            }

            const objHeader = {
              type: 'header',
              ...objHeaderTemp
            }
            this.chat.hsm.history.components.push(objHeader)
            this.media_header = true
          }
        })
        this.set_preview_body();
        this.set_preview_footer();
        this.set_preview_button();
        this.set_preview_header();

      }
    },

    isOperator(department_id) {
      if (department_id === null) {
        department_id = this.getChannelObject('id', this.chat.ticket.channel_id)
      }
      let operator = this.operators.data.find(operator => {
        return operator.department_id === department_id && operator.user_id === this.me.data.id;
      });
      if (operator !== undefined) {
        return operator.id
      } else {
        return null
      }
    },

    sendHsm() {
      const history = {
        channel_id: this.chat.ticket.channel_id,
        ticket_id: this.chat.ticket.id,
        operator_id: this.isOperator(this.chat.ticket.department_id),
        department_id: this.chat.ticket.department_id,
        file: this.file.file,
        hsm: {
          header: this.preview_header,
          body: this.preview_body,
          footer: this.preview_footer,
          buttons: this.preview_button,
          props: this.chat.hsm.history
        }
      }
      this.$store.dispatch('sendHsm', history)
      this.closeModal();
    },


    // EMOJIS E VARIÁVEIS
    selectVariable(inputMsgId, data) {
      this.inputMsgId = inputMsgId;
      const paramaterText = this.$refs[`editvariables_modal_${this.inputMsgId}`];
      if (this.inputMsgId && (paramaterText[0].value.length !== undefined && data.code.length + paramaterText[0].value.length <= 30)
        || (paramaterText.length === undefined && data.code.length + paramaterText.value.length <= 30)) {
        let text = null;
        if (paramaterText.length === undefined) {
          this.startPosition = paramaterText.selectionStart;
          this.endPosition = paramaterText.selectionEnd;
          paramaterText.setSelectionRange(this.startPosition, this.endPosition);
          text = paramaterText.value;
        } else {
          this.startPosition = paramaterText[0].selectionStart;
          this.endPosition = paramaterText[0].selectionEnd;
          paramaterText[0].setSelectionRange(this.startPosition, this.endPosition);
          text = paramaterText[0].value;
        }

        if (["", null].includes(text)) {
          if (this.inputMsgId === 1) {
            this.chat.hsm.history.components[this.index_header].parameters[0].text = data.code;
          } else if (parseInt(this.inputMsgId.split("_")[0]) === 2) {
            const body_components = this.chat.hsm.history.components.filter(component => ['body', 'BODY'].includes(component.type))
            body_components[0].parameters[parseInt(this.inputMsgId.split("_")[1])].text = data.code;
          } else if (this.inputMsgId === 3) {
            this.chat.hsm.history.components[this.index_button_url].parameters[0].text = data.code;
          }

        } else {
          const textBefore = text.substring(0, this.startPosition);
          const textAfter = text.substring(this.endPosition, text.length);
          this.startPosition += data.code.length;

          if (this.inputMsgId === 1) {
            this.chat.hsm.history.components[this.index_header].parameters[0].text = `${textBefore}${data.code}${textAfter}`;
          } else if (parseInt(this.inputMsgId.split("_")[0]) === 2) {
            const body_components = this.chat.hsm.history.components.filter(component => ['body', 'BODY'].includes(component.type))
            body_components[0].parameters[parseInt(this.inputMsgId.split("_")[1])].text = `${textBefore}${data.code}${textAfter}`;
          } else if (this.inputMsgId === 3) {
            this.chat.hsm.history.components[this.index_button_url].parameters[0].text = `${textBefore}${data.code}${textAfter}`;
          }

        }
        setTimeout(() => {

          if (paramaterText.length === undefined) {
            paramaterText.setSelectionRange(this.startPosition, this.startPosition);
            paramaterText.focus()
          } else {
            paramaterText[0].setSelectionRange(this.startPosition, this.startPosition);
            paramaterText[0].focus()
          }
          this.set_preview_body()
          this.set_preview_button()
          this.set_preview_footer()
          this.set_preview_header()
        }, 100)
      }
      else {
        Swal.fire(
          `${this.getTranslations('expression_683')}`,
          `${this.getTranslations('expression_1204')} <br/> <small>${this.getTranslations('expression_1205')} ${data.code} ${this.getTranslations('expression_1206')}</small>`,
          'warning'
        )
      }
    },
    dropdownActive(id) {
      if (this.dropdownShow === id) {
        this.dropdownShow = false
      } else {
        this.dropdownShow = id
      }
    }
  }
}
</script>

<style src="../../assets/css/modals/ModalSendTemplateHSM.css" scoped></style>
